import { ActionPanel } from "../actionPanel/ActionPanel";
import { Button, Icon } from "@sellar-io/components";
import { useState } from "react";
import { useOrderCancel } from "../../hooks/api/v2/order/v2/useOrderCancel";
import { useToast } from "../toast/useToast.shared";
import { Toast } from "../toast/Toast";
import { PayWithSellarCreditButton } from "../../pages/stockList/checkoutV2/lib/PayWithSellarCreditButton";
import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useSellarCreditPaymentStatus } from "./useSellarCreditPaymentStatus";

type PayWithSellarCreditActionPanelProps = {
  orderId: number;
  orderDeferredPaymentId: string | null;
  twoOrder: OrderGetResponseType["TwoOrder"];
};

export const PayWithSellarCreditActionPanelLegacy = ({
  orderId,
}: PayWithSellarCreditActionPanelProps) => {
  const { toast } = useToast();
  const orderCancelMutation = useOrderCancel();
  const [isCancellingOrder, setIsCancellingOrder] = useState(false);
  const { isProcessed } = useSellarCreditPaymentStatus({
    orderId,
  });

  const handleCancelOrder = async ({
    orderId,
    onSuccess,
  }: {
    orderId: number;
    onSuccess: () => void;
  }) => {
    setIsCancellingOrder(true);
    await orderCancelMutation.mutateAsync(
      {
        id: orderId,
        data: {
          cancellationReason: "Could not place order with Sellar Credit",
          cancelledAt: new Date(),
          cancelledBy: "retailer",
          orderComment: null,
        },
      },
      {
        onSuccess,
        onError: () => {
          setIsCancellingOrder(false);
          const message = `Could not cancel your order at this time, please try again.`;
          toast({
            placement: "bottom",
            render: () => <Toast icon="ALERT">{message}</Toast>,
          });
        },
      },
    );
  };

  if (isProcessed) {
    return null;
  }

  return (
    <>
      <ActionPanel
        className="flex flex-col gap-4"
        title="Payment using Sellar Credit not processed"
      >
        <div className="flex flex-col gap-4">
          <p>
            Your payment using Sellar Credit was not processed. Try your payment
            again using the button below
          </p>
          <PayWithSellarCreditButton
            orderId={orderId}
            renderTrigger={({ loading, disabled, onClick }) => {
              return (
                <Button
                  onClick={onClick}
                  className="w-full md:w-min"
                  disabled={disabled}
                  loading={loading}
                >
                  <Icon icon="SELLAR_NEW" className="text-white" />
                  Pay with Sellar Credit
                </Button>
              );
            }}
            cancelOrderButtonProps={{
              loading: isCancellingOrder,
              disabled: isCancellingOrder,
              onClick: (orderId) => {
                handleCancelOrder({
                  orderId,
                  onSuccess: () => {
                    window.location.reload();
                  },
                });
              },
            }}
            onSuccess={(response) => {
              if (response.paymentUrl) {
                window.location.replace(response.paymentUrl);
                return;
              }
              window.location.reload();
            }}
            onError={() => {
              // Rely on internal error handling alone
            }}
          />
        </div>
      </ActionPanel>
    </>
  );
};
